import { __assign } from "tslib";
/**
* Set a custom attribute
*/
export function setAttribute(name, value) {
  if (window.NREUM) {
    window.NREUM.setCustomAttribute(name, value);
  }
}
/**
* Remove a custom attribute
*/
export function removeAttribute(name) {
  // Note: New Relic Browser agent doesn't have a direct method to remove attributes
  // Setting to undefined/null is the closest alternative
  if (window.NREUM) {
    window.NREUM.setCustomAttribute(name, undefined);
  }
}
// Utility to track custom events (for both Web and Native)
export function trackCustomEvent(eventName, customAttributes) {
  if (customAttributes === void 0) {
    customAttributes = {};
  }
  if (typeof window !== 'undefined') {
    // For React Web (Browser)
    if (window.NREUM) {
      // Ensure New Relic is ready before tracking events
      window.NREUM.addPageAction(eventName, __assign(__assign({}, customAttributes), {
        timestamp: new Date().toISOString()
      }));
    } else {
      // New Relic script hasn't loaded yet, retry after a short delay
      console.warn('New Relic is not ready. Retrying...');
    }
  }
}
export function trackInteraction(interactionName, customAttributes, isStart) {
  if (customAttributes === void 0) {
    customAttributes = {};
  }
  if (isStart === void 0) {
    isStart = true;
  }
  var actionType = isStart ? 'start' : 'end';
  if (typeof window !== 'undefined') {
    if (window.NREUM) {
      // For React Web (Browser)
      window.NREUM.addPageAction("".concat(interactionName).concat(actionType), __assign(__assign({}, customAttributes), {
        timestamp: new Date().toISOString(),
        action: actionType
      }));
    } else {
      // New Relic script hasn't loaded yet, retry after a short delay
      console.warn('New Relic is not ready. Retrying...');
    }
  }
}